'use strict';

import template from './guide_activities.html';

function swap(obj){
  var ret = {};
  for(var key in obj){
    ret[obj[key]] = key;
  }
  return ret;
}

const saGuideActivities = function () {
  return {
    template: template,
    replace: true,
    scope: {
      activities: '=',
      country: '=',
      city: '=',
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: function f(activityIcons, seoActivities) {
      'ngInject';

      this.rSeoActivities = swap(seoActivities);
      this.activityIcons = activityIcons;
    }
  };
};

export default saGuideActivities;



// WEBPACK FOOTER //
// ./app/src/directives/guide_activities.js